import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'boolean' })
export class BooleanPipe implements PipeTransform {
  public transform(value, display = [$localize`Yes`, $localize`No`]) {
    if (typeof value === 'undefined' || value === null) return;
    if (value) return display[0];
    return display[1];
  }
}
